import { getCookie } from "./cookies";

const allowedLangs = ["en", "de", "es", "fr", "it"];

export function getCookieLang(): string | undefined {
	let cookieLang = getCookie("lang");
	if (!cookieLang || cookieLang === "undefined") {
		return undefined;
	}

	return cookieLang;
}

export function getShortLang(defaultLang = "en"): string {
	let lang = navigator.language.substr(0, 2);
	if (allowedLangs.indexOf(lang) === -1) {
		lang = defaultLang;
	}

	return lang;
}
